const packageJson = require('../package.json')
export const version = `v${packageJson.version}`
